<script setup lang="ts">
import { defineProps } from "vue";
import AppTooltip from "@/components/AppTooltip.vue";

const props = defineProps<{
  years: {
    element: string;
    hit_palace: string;
    stage: string;
    trend: number;
    year: number;
    year_pillar: string;
  }[];
  palaces: Record<string, string>;
}>();

const elementNames: Record<string, string> = {
  木: "wood",
  火: "fire",
  土: "earth",
  金: "metal",
  水: "water",
};

function trendClass(trend: string): string {
  if (trend === "unfavorable") {
    return "border-[#f5c6cb]";
  }
  if (trend === "favorable") {
    return "border-[#c3e6cb]";
  }
  return "border-[#d6d8db]";
}
</script>

<template>
  <div class="grid grid-cols-1 md:grid-cols-9 gap-[10px]">
    <div
      v-for="(item, index) in props.years.slice(0, 27)"
      :key="index"
      class="flex md:flex-col gap-4 py-2 border-2 rounded-lg flex-grow max-md:px-4 items-center max-md:justify-between bg-white"
      :class="trendClass(item.trend)"
    >
      <!-- Год -->
      <p class="font-semibold text-xl leading-[24px]">
        {{ item.year }}
      </p>

      <!-- Столп года -->
      <AppTooltip>
        <template #trigger>
          <p class="cursor-pointer text-xl leading-[24px]">
            {{ item.year_pillar }}
          </p>
        </template>
        <template #popper>
          <div class="max-w-96 text-left">
            {{ item.tips.pillar }}
          </div>
        </template>
      </AppTooltip>

      <!-- Стихия -->
      <AppTooltip>
        <template #trigger>
          <img
            :src="
              require(`@/assets/calculators/bazi/${
                elementNames[item.element]
              }.png`)
            "
            :alt="item.element"
            class="element-img cursor-pointer mx-auto size-10"
          />
        </template>
        <template #popper>
          <div class="max-w-96 text-left">
            {{ item.tips.element }}
          </div>
        </template>
      </AppTooltip>

      <!-- Стадия -->
      <AppTooltip>
        <template #trigger>
          <p class="cursor-pointer text-base leading-[20px] min-w-[40px]">
            {{ item.stage }}
          </p>
        </template>
        <template #popper>
          <div class="max-w-96">
            <h5>{{ item.tips.stage_label }}</h5>
            <div class="text-left">{{ item.tips.stage }}</div>
          </div>
        </template>
      </AppTooltip>

      <!-- Дворец -->
      <AppTooltip>
        <template #trigger>
          <p class="cursor-pointer text-base leading-[20px]">
            {{ palaces[item.hit_palace]["hieroglyph"] }}
          </p>
        </template>
        <template #popper>
          <div class="max-w-96">
            <h5>{{ item.tips.palace_label }}</h5>
            <div class="text-left">
              {{ item.tips.palace_description }}
            </div>
          </div>
        </template>
      </AppTooltip>
    </div>
  </div>
</template>
